module.exports = __webpack_public_path__ + "media/images/arrow-cf9a8f352b8ed29bb0c33542dec0f436.svg";